import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const Footer = () => {
  const { language } = useLanguage();
  
  const quickLinks = [
    { nameKey: "footerSection.home", href: "#home" },
    { nameKey: "footerSection.features", href: "#features" },
    { nameKey: "footerSection.modules", href: "#modules" },
    { nameKey: "footerSection.benefits", href: "#benefits" },
    { nameKey: "footerSection.faq", href: "#faq" },
    { nameKey: "footerSection.contact", href: "#contact" }
  ];

  const modules = [
    "footerSection.admissionManagement",
    "footerSection.feeManagement",
    "footerSection.attendanceSystem",
    "footerSection.examinationModule",
    "footerSection.hrPayroll",
    "footerSection.mobileApp"
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand">
              <img src='TA.png' alt='..' style={{ height: 40, marginBottom: 16, backgroundColor: 'white', padding: 8 }}/>
              <p>
                {getTranslation(language, 'footerSection.brandDesc')}
              </p>
            </div>
          </div>
          
          <div className="col-lg-2 col-md-6">
            <div className="footer-links">
              <h5>{getTranslation(language, 'footerSection.quickLinks')}</h5>
              <ul>
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{getTranslation(language, link.nameKey)}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <div className="footer-links">
              <h5>{getTranslation(language, 'footerSection.ourModules')}</h5>
              <ul>
                {modules.map((moduleKey, index) => (
                  <li key={index}>
                    <a href="#modules">{getTranslation(language, moduleKey)}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <div className="footer-contact">
              <h5>{getTranslation(language, 'footerSection.contactUs')}</h5>
              <div className="footer-contact-item">
                <i className="bi bi-geo-alt-fill"></i>
                <p>{getTranslation(language, 'footerSection.address1')}</p>
              </div>
              <div className="footer-contact-item">
                <i className="bi bi-geo-alt-fill"></i>
                <p>{getTranslation(language, 'footerSection.address2')}</p>
              </div>
              <div className="footer-contact-item">
                <i className="bi bi-telephone-fill"></i>
                <p>{getTranslation(language, 'footerSection.phone')}</p>
              </div>
              <div className="footer-contact-item">
                <i className="bi bi-envelope-fill"></i>
                <p>{getTranslation(language, 'footerSection.email')}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom text-center">
          <p>{getTranslation(language, 'footerSection.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
